export const API_PATH = process.env.REACT_APP_API_URL;
export const AUTHENTICATION_API_PATH = API_PATH + "/v3/ui-auth";
export const DASHBOARD_API_PATH = API_PATH + "/v3/dashboards";
export const UTILS_API_PATH = API_PATH + "/v3/utils";
export const MERCHANT_GROUP_API_PATH = API_PATH + "/v3/merchant-groups";
export const MERCHANT_API_PATH = API_PATH + "/v3/merchants";
export const STORE_API_PATH = API_PATH + "/v3/stores";
export const KEYWORD_API_PATH = API_PATH + "/v3/keywords";
export const OFFER_API_PATH = API_PATH + "/v3/offers";
export const SUBSCRIBERS_API_PATH = API_PATH + "/v3/subscribers";
export const CAMPAIGN_API_PATH = API_PATH + "/v3/campaigns";
export const CRITERION_API_PATH = API_PATH + "/v3/criteria";
export const DISPATCH_API_PATH = API_PATH + "/v3/dispatches";
export const LOOKUP_API_PATH = API_PATH + "/v3/subscribers";
export const PREVIEW_API_PATH = API_PATH + "/v3/preview";
export const LIST_API_PATH = API_PATH + "/v3/lists";
export const USERS_API_PATH = API_PATH + "/v3/users";
export const INTEGRATIONS_API_PATH = API_PATH + "/v3/integrations";
export const SUBSCRIBERS_IMPORT_API_PATH = API_PATH + "/v3/subscriber-imports";
export const STORE_GROUPS_API_PATH = API_PATH + "/v3/store-groups";
export const STORES_IMPORT_API_PATH = API_PATH + "/v3/store-imports";
export const ACCOUNTS_API_PATH = API_PATH + "/v3/accounts";
export const PRINCIPALS_API_PATH = API_PATH + "/v3/principals";
export const NUMBER_REQUESTS_API_PATH = API_PATH + "/v3/number-requests";
export const SMART_LINKS_API_PATH = API_PATH + "/v3/smart-links";
export const CHATS_API_PATH = API_PATH + "/chats/v1";
export const CHATS_EVENT_BUS_PATH = `${API_PATH}/chats/event-bus`;
export const SUBSCRIBER_EXPORTS_API_PATH = API_PATH + "/v3/subscriber-exports";
export const UNSUBSCRIBE_IMPORTS_API_PATH =
  API_PATH + "/v3/unsubscribe-imports";
export const COUPON_IMPORTS_API_PATH = API_PATH + "/v3/coupon-imports";
export const COUPON_GROUPS_API_PATH = API_PATH + "/v3/coupon-groups";
export const VIRTUAL_NUMBERS_API_PATH = API_PATH + "/v3/virtual-numbers";
export const BILLINGS_API_PATH = API_PATH + "/v3/billing-exports";
export const DISPATCH_SUMMARY_EXPORTS_API_PATH =
  API_PATH + "/v3/dispatch-summary-exports";
export const DISPATCH_SUBSCRIBER_EXPORTS_API_PATH =
  API_PATH + "/v3/dispatch-subscriber-exports";
